import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { AuthShell, inputCls, btnCls } from "@/pages/AuthShell";
import { Loader2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      formatApiError(err.response?.data?.detail);
      setDone(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Reset your password"
      subtitle="We'll send you a reset link"
      footer={<Link to="/login" className="font-semibold text-blue-600">Back to login</Link>}
    >
      {done ? (
        <div data-testid="forgot-done" className="rounded-xl bg-blue-50 text-blue-700 p-4 text-sm">
          If an account exists for that email, a reset link has been generated. (In this MVP the link is printed to the backend console.)
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <input data-testid="forgot-email" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} required />
          <button data-testid="forgot-submit" type="submit" disabled={loading} className={btnCls}>
            {loading ? <Loader2 className="w-4 h-4 animate-spin mx-auto" /> : "Send reset link"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
